import React from 'react';
import CapIcon from '../../CapIcon';
import { rootClsPrefix as clsPrefix } from '../constants';

const DEFAULT_ICON_SIZE = '1.9rem';

const IconHOC = Icon => {
  const Wrapper = ({
    round,
    className,
    iconSize = DEFAULT_ICON_SIZE,
    svgProps = {},
    ...props
  }) => {
    return (
      <Icon
        className={`${className} ${round ? `${clsPrefix}-round` : ''}`}
        svgProps={{
          ...svgProps,
          style: {
            width: iconSize,
            height: iconSize,
            ...(svgProps.style || {}),
          },
        }}
        {...props}
      />
    );
  };
  return Wrapper;
};

export const AiraRound = IconHOC(props => {
  return <CapIcon type="aira-bot-dark" {...props} />;
});

export const AiraCorner = IconHOC(props => {
  return <CapIcon type="aira-bot-title" {...props} />;
});

export const AiraFAB = IconHOC(props => {
  return <CapIcon type="aira-bot-fab" {...props} />;
});

export const AiraChatBot = IconHOC(props => {
  return <CapIcon type="chat-bot" {...props} />;
});

export const AiraChatTitleBar = IconHOC(props => {
  return <CapIcon type="aira-chat-title-bar" {...props} />;
});
